import themeStyles from '../styles/themes.module.scss';
import { Locale, ShopBundle } from '../types';

import AppContextProvider from './AppContextProvider';
import OverlaysProvider from './OverlaysProvider';

export type ProvidersProps = {
  shopBundle: ShopBundle;
  locale: Locale;
  domain: string;
  csrfToken?: string;
};

const Providers: React.FC<ProvidersProps> = ({
  children,
  shopBundle,
  domain,
  locale,
  csrfToken,
}) => {
  return (
    <div className={themeStyles[shopBundle]}>
      <AppContextProvider value={{ shopBundle, locale, domain, csrfToken }}>
        <OverlaysProvider>{children}</OverlaysProvider>
      </AppContextProvider>
    </div>
  );
};

export default Providers;
